import { useEffect } from 'react';
import { useScrollState } from '../useScrollState/useScrollState.esm.js';
import { useBaseLottie } from './useBaseLottie.esm.js';

var calcIntersection = function(value, size, total, threshold) {
    return {
        intersect: value <= total * (1 - threshold) && value >= -size,
        contain: value <= (total - size) * (1 - threshold) && value >= 0
    };
};
var isInViewport = function(element, param) {
    var x = param.x, y = param.y;
    var _element_getBoundingClientRect = element.getBoundingClientRect(), top = _element_getBoundingClientRect.top, left = _element_getBoundingClientRect.left, width = _element_getBoundingClientRect.width, height = _element_getBoundingClientRect.height;
    var _window_innerHeight;
    var viewportHeight = (_window_innerHeight = window.innerHeight) !== null && _window_innerHeight !== void 0 ? _window_innerHeight : document.documentElement.clientHeight;
    var _window_innerWidth;
    var viewportWidth = (_window_innerWidth = window.innerWidth) !== null && _window_innerWidth !== void 0 ? _window_innerWidth : document.documentElement.clientWidth;
    var yAxis = (y === null || y === void 0 ? void 0 : y.threshold) != null ? calcIntersection(top, height, viewportHeight, y.threshold)[y.condition] : true;
    var xAxis = (x === null || x === void 0 ? void 0 : x.threshold) != null ? calcIntersection(left, width, viewportWidth, x.threshold)[x.condition] : true;
    return yAxis && xAxis;
};
// eslint-disable-next-line no-prototype-builtins
var isSingleAxisTrigger = function(trigger) {
    return trigger.hasOwnProperty("condition");
};
var isDualAxisTrigger = function(trigger) {
    return(// eslint-disable-next-line no-prototype-builtins
    trigger.hasOwnProperty("x") || trigger.hasOwnProperty("y"));
};
var useLottie = function(elementRef, param) {
    var animationData = param.animationData, _param_lottieConfig = param.lottieConfig, lottieConfig = _param_lottieConfig === void 0 ? {} : _param_lottieConfig, tmp = param.scrollOptions, _ref = tmp === void 0 ? {} : tmp, _ref_pauseOnScroll = _ref.pauseOnScroll, pauseOnScroll = _ref_pauseOnScroll === void 0 ? false : _ref_pauseOnScroll, playTrigger = _ref.playTrigger;
    var lottie = useBaseLottie(elementRef, {
        animationData: animationData,
        lottieConfig: lottieConfig
    });
    var isScrolling = useScrollState({
        active: pauseOnScroll || playTrigger != null
    }).isScrolling;
    useEffect(function() {
        if (isScrolling && pauseOnScroll) {
            lottie === null || lottie === void 0 ? void 0 : lottie.pause();
            return;
        }
        if (elementRef.current == null || playTrigger == null) return;
        var xAxis = isDualAxisTrigger(playTrigger) ? playTrigger.x : undefined;
        var yAxis = isSingleAxisTrigger(playTrigger) ? {
            threshold: playTrigger.threshold,
            condition: playTrigger.condition
        } : playTrigger.y;
        var shouldPlay = isInViewport(elementRef.current, {
            x: xAxis,
            y: yAxis
        });
        if (shouldPlay || !playTrigger.pauseIfConditionsUnmet) {
            lottie === null || lottie === void 0 ? void 0 : lottie.play();
        } else {
            lottie === null || lottie === void 0 ? void 0 : lottie.pause();
        }
    }, [
        elementRef,
        isScrolling,
        lottie,
        lottieConfig.autoplay,
        pauseOnScroll,
        playTrigger
    ]);
    return lottie;
};

export { useLottie };
